import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_FOUNDERS_START, POST_FOUNDERS_ERROR, POST_FOUNDERS_START, POST_FOUNDERS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* create({ payload }) {
  try {
    const url = '/founders/create';
    const method = 'POST';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: POST_FOUNDERS_SUCCESS, results: results.data });
  } catch (error) {
    console.log(error)
    yield put({ type: POST_FOUNDERS_ERROR, error });
  } finally {
    yield put({ type: GET_FOUNDERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* post_founders() {
    yield takeLatest(POST_FOUNDERS_START, create);
}